// extracted by mini-css-extract-plugin
export default {"content":"CampaignAmount_content__ko6yL","campaignCategoryItem":"CampaignAmount_campaignCategoryItem__qkDLF"};